var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44401 11.4353H1.66623C1.17557 11.4353 0.777344 11.0383 0.777344 10.547V6.99378C0.777344 6.50254 1.17557 6.10547 1.66623 6.10547H12.3329C12.8236 6.10547 13.2218 6.50254 13.2218 6.99378V10.547C13.2218 11.0383 12.8236 11.4353 12.3329 11.4353H10.5551",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44531 6.1072V1.66565C3.44531 1.17442 3.84353 0.777344 4.3342 0.777344H9.66753C10.1582 0.777344 10.5564 1.17442 10.5564 1.66565V6.1072",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66753 13.2134H4.3342C3.84353 13.2134 3.44531 12.8163 3.44531 12.3251V10.5485C3.44531 10.0572 3.84353 9.66016 4.3342 9.66016H9.66753C10.1582 9.66016 10.5564 10.0572 10.5564 10.5485V12.3251C10.5564 12.8163 10.1582 13.2134 9.66753 13.2134Z",
    stroke: "#8A939A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.1e9692dee1c7b0297691477664727740.svg";
export { ForwardRef as ReactComponent };